<template>
    <form-group label="Technical Descriptions" label-width="8" input-width="16">
        <div v-if="value.length">
            <div v-for="(technicalDescription, index) in value" style="margin-bottom: 12px">
                <div class="row">
                    <div class="col-xs-9" :class="{'has-error': (errors['technical_descriptions.' + index + '.key'] || []).length }">
                        <input
                                type="text"
                                class="form-control has-error"
                                placeholder="Key"
                                :value="technicalDescription.key"
                                @input="input(index, 'key', $event.target.value)"
                        >
                    </div>

                    <div class="col-xs-9" :class="{'has-error': (errors['technical_descriptions.' + index + '.value'] || []).length }">
                        <input
                                type="text"
                                class="form-control"
                                placeholder="Value"
                                :value="technicalDescription.value"
                                @input="input(index, 'value', $event.target.value)"
                        >
                    </div>

                    <div class="col-xs-6">
                        <button type="button" class="btn btn-link" @click="remove(index)">
                            <i class="fa fa-minus"></i> Remove
                        </button>
                    </div>
                </div>

                <div :class="{'has-error': hasRowError(index)}">
                    <span class="help-block">
                        {{ (errors['technical_descriptions.' + index + '.key'] || errors['technical_descriptions.' + index + '.value'] || [])[0] }}
                    </span>
                </div>
            </div>
        </div>

        <div style="margin: 7px 0" v-else>
            <i>
                No technical descriptions have been added.
            </i>
        </div>

        <button type="button" class="btn btn-xs btn-black" @click="add">
            <i class="fa fa-plus"></i> Add
        </button>
    </form-group>
</template>

<script>
    import FormGroup from "@/vendor/forms/FormGroups/Horizontal/FormGroup"

    export default {
        components: {FormGroup},

        props: {
            value: {},
            errors: {},
        },

        methods: {
            add() {
                let technicalDescriptions = [...this.value]

                technicalDescriptions.push({})

                this.$emit('input', technicalDescriptions)
            },

            remove(index) {
                let technicalDescriptions = [...this.value]

                technicalDescriptions.splice(index, 1)

                this.$emit('input', technicalDescriptions)
            },

            input(index, key, value) {
                let technicalDescriptions = [...this.value]

                technicalDescriptions[index][key] = value

                this.$emit('input', technicalDescriptions)
            },

            hasRowError(index) {
                return Object.keys(this.errors).some(key => key.startsWith('technical_descriptions.' + index + '.'))
            }
        }
    }
</script>
